import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import CompanyService from "../services/CompanyService";

export const CompanyContext = createContext("CompanyContext");

const CompanyContextProvider = ({ children }) => {
	const [companyList, setCompanyList] = useState([]);
	const [loadingCompanyList, setLoadingCompanyList] = useState(false);
	const [companyListErrorMsg, setCompanyListErrorMsg] = useState("");
	const [totalElements, setTotalElements] = useState(0);

	const getCompanyList = async (params) => {
		setLoadingCompanyList(true);
		setCompanyListErrorMsg("");
		try {
			const response = await CompanyService.getCompanyList(params);
			setCompanyList(response.data.content);
			setTotalElements(response.data.totalElements);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setCompanyListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingCompanyList(false);
		}
	};

	return (
		<CompanyContext.Provider
			value={{
				getCompanyList,
				companyList,
				totalElements,
				loadingCompanyList,
				companyListErrorMsg,
			}}
		>
			{children}
		</CompanyContext.Provider>
	);
};

export default CompanyContextProvider;
